import {
    Button,
    Spinner,
    Table, TableBody,
    TableCell,
    TableCellActions,
    TableCellLayout,
    TableHeader,
    TableHeaderCell,
    TableRow,
    makeStyles, shorthands
} from "@fluentui/react-components";
import axios from "axios";
import { Base_Url} from "./services/firebase";
// import { toast } from "react-hot-toast";
import { DeleteFilled, DeleteRegular, EditFilled, EditRegular, bundleIcon } from "@fluentui/react-icons";
import { collection, getDocs, query, where } from "firebase/firestore";
import debounce from 'lodash/debounce';
import moment from 'moment';
import React, { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router-dom";
import CustomSearchInput from "./components/CustomSearchInput";
import ImageDialog from "./components/ImageDialog";
import Layout from "./components/Layout";
import { auth, db, trackException } from "./services/firebase";
import PostDataService from "./services/postDataService";
import RSVPCancelRequestService from "./services/RSVPCancelRequestService";
import NotificationDataService from "./services/notificationDataService";
import useBreakpoint from "./hooks/useBreakpoint";  
import "./components/Forms/FormStyle.css"
const EditIcon = bundleIcon(EditFilled, EditRegular);
const DeleteIcon = bundleIcon(DeleteFilled, DeleteRegular);

const useStyles = makeStyles({
    root: {
        ...shorthands.overflow("hidden"),
        display: "flex",
        height: "480px",
        backgroundColor: "#fff"
    },

    content: {
        ...shorthands.flex(1),
        ...shorthands.padding("16px"),
        display: "block",
        ...shorthands.gridArea("main")
    },

    breakFlex: {
        flexBasis: "100%",
        textAlign: "left"
    }
});

const columns = [
    { columnKey: "eventName", label: "Event Name" ,  width: '20%'},
    { columnKey: "Name", label: "Name", width: '20%' },
    { columnKey: "status", label: "Status", width: '10%' },
    { columnKey: "-", label: "-", width: '50%' }
];

function EventRSVPCancelRequest() {
    const styles = useStyles();
    const navigate = useNavigate();
    const [user, loading, error] = useAuthState(auth);
    const [isFormOpen, setIsFormOpen] = useState(false);
    const [selectedPost, setSelectedPost] = useState();
    const [allposts, setAllPosts] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredPosts, setFilteredPosts] = useState([]);
    const [open, setOpen] = React.useState(false);
    const [isDeleteDialogOpen, setIsDeleteDialogOpen] = React.useState(false);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(50); // Number of events per page
    const [startAfterDoc, setStartAfterDoc] = useState(null); // Track the last document of the previous page
    const [isLoading, setIsLoading] = useState(false);
    const [hasMoreData, setHasMoreData] = useState(true);
    const breakpoint = useBreakpoint();
    const isMobile = breakpoint === "mobile";
 

    useEffect(() => {
        if (loading) return;
        if (!user) return navigate("/");
        setIsLoading(true);
        fetchUserNameAndRSVPCancelRequest();
    }, [user, loading]);
    useEffect(() => {
        if (page > 1) {
            loadMorePosts();
        }
    }, [page]);

    const openForm = (selectedItem) => {
        setIsFormOpen(true);
        setSelectedPost(selectedItem);
    }


async function sendEmailToMember(item) {
  try {
    const selectedMember = item?.email;

    const username = `${item?.firstName || ''} ${item?.lastName || ''}`.trim();
    const emailId = item?.email;
    const eventName = item?.eventName;
    const id = item?.id;

    const cancellationDate = new Date().toLocaleDateString("en-US", {
      timeZone: "America/Denver",
    });

    const messageForMember = {
        subject: `RSVP cancelled successfully. - ${username}`,
        html: `
                Hi <strong>${username}</strong>,<br/>
                Your booking for <strong>${eventName}</strong> has been successfully cancelled. Booking Ref: ${id}<br/>
                Cancellation date: ${new Date().toLocaleDateString("en-US", {
                timeZone: "America/Denver",
                })}.
            `,
      };

    const emailForMember = {
      to: [emailId],
      message: messageForMember,
    };

    // Send email
    const response = await NotificationDataService.addEmail(emailForMember);

  } catch (error) {
    console.error("Error sending cancellation email:", error);
  }
}



      async function approveClick(item) {
        if (!item?.userId || !item?.eventId) {
            console.log("Missing userId or eventId");
            return;
        }

        setIsLoading(true);

        try {
            const payload = {
            eventId: item.eventId,
            userId: item.userId,
            rsvpCancelRequestId: item?.id || "",
            cancleStatus: 1,
            giveRefund: false, 
            };

            const response = await axios.post(`${Base_Url}/cancelRSVP`, payload, {
            headers: {
                    "Content-Type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    'Authorization': `Bearer ${user.accessToken}`,
                    Accept: "application/json",
                },
            });

            if (response?.status === 200) {
            console.log("RSVP cancelled successfully");
            } else {
            console.log("Failed to cancel RSVP");
            }
        } catch (error) {
            console.error("Error cancelling RSVP:", error);
        } finally {
            setIsLoading(false);
            fetchUserNameAndRSVPCancelRequest();
            sendEmailToMember(item);
        }
        }

     async function approveAndRefundClick(item) {
        if (!item?.userId || !item?.eventId) {
            console.log("Missing userId or eventId");
            return;
        }

        setIsLoading(true);

        try {
            const payload = {
            eventId: item.eventId,
            userId: item.userId,
            rsvpCancelRequestId: item?.id || "",
            cancleStatus: 2,
            giveRefund: true, 
            };

            const response = await axios.post(`${Base_Url}/cancelRSVP`, payload, {
            headers: {
                    "Content-Type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    'Authorization': `Bearer ${user.accessToken}`,
                    Accept: "application/json",
                },
            });

            if (response?.status === 200) {
            console.log("RSVP cancelled successfully");
            } else {
            console.log("Failed to cancel RSVP");
            }
        } catch (error) {
            console.error("Error cancelling RSVP:", error);
        } finally {
            setIsLoading(false);
            fetchUserNameAndRSVPCancelRequest();
            sendEmailToMember(item);
        }
        }


     async function declineClick(item) {
        if (!item?.userId || !item?.eventId) {
            console.log("Missing userId or eventId");
            return;
        }

        setIsLoading(true);

        try {
            const payload = {
            eventId: item.eventId,
            userId: item.userId,
            rsvpCancelRequestId: item?.id || "",
            cancleStatus: 3,
            giveRefund: false, 
            };

            const response = await axios.post(`${Base_Url}/cancelRSVP`, payload, {
            headers: {
                    "Content-Type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    'Authorization': `Bearer ${user.accessToken}`,
                    Accept: "application/json",
                },
            });

            if (response?.status === 200) {
            console.log("RSVP cancelled successfully");
            } else {
            console.log("Failed to cancel RSVP");
            }
        } catch (error) {
            console.error("Error cancelling RSVP:", error);
        } finally {
            setIsLoading(false);
            fetchUserNameAndRSVPCancelRequest();
        }
        }

    const fetchUserNameAndRSVPCancelRequest = async () => {
        setPage(1)
        setStartAfterDoc(null)
        setHasMoreData(true)
        try {
            if (!!user) {
                const userquery = query(collection(db, "Users"), where("email", "==", user?.email));
                const userdoc = await getDocs(userquery);
                if (userdoc.docs.length > 0) {
                    const { events, lastVisible } = await RSVPCancelRequestService.getAllPostsRSVPCancelRequest(pageSize, null);
                    // Update the startAfterDoc for the next page
                    setStartAfterDoc(lastVisible);
                    let allEventArr = events
                    setAllPosts(allEventArr);
                    setFilteredPosts(allEventArr)
                    if (allEventArr.length < pageSize) {
                        setHasMoreData(false)
                    }
                    //console.log(allevents);
                } else {
                    console.log('no access');
                }
                setIsLoading(false);
            }
        } catch (err) {
            trackException(JSON.stringify(err))
            setIsLoading(false);
            console.error(err);
            alert("An error occured while fetching user data");
        }
    };

    const loadMorePosts = async () => {
        const { events, lastVisible } = await RSVPCancelRequestService.getAllPostsWithPage(pageSize, startAfterDoc);
        // Update the startAfterDoc for the next page
        setStartAfterDoc(lastVisible);
        if (events.length < pageSize) {
            setHasMoreData(false)
            if (events.length > 0) {
                setAllPosts(prevEvents => [...prevEvents, ...events]);
                setFilteredPosts(prevEvents => [...prevEvents, ...events]);
            }
            // You can handle this case, e.g., display a message
        } else {
            // Append the new events to the existing events
            setAllPosts(prevEvents => [...prevEvents, ...events]);
            setFilteredPosts(prevEvents => [...prevEvents, ...events]);
        }
    };

    // Debounce the handleSearch function
    const debouncedSearch = debounce(search => {
        const lowerSearch = search.toLowerCase();
        const filtered = allposts.filter(event =>
            event.eventName.toLowerCase().includes(lowerSearch)
        );
        setFilteredPosts(filtered);
    }, 300); // Adjust the debounce delay as needed

    const handleSearch = event => {
        const value = event.target.value;
        setSearchTerm(value);
        debouncedSearch(value);
    };
    const handleClear = () => {
        setSearchTerm('');
        debouncedSearch('');
    };
    const handleLoadMore = () => {
        setPage(prevPage => prevPage + 1);
    };

    return (
        <Layout>
            <div className={styles.content}>
                <div className={styles.breakFlex}>
                </div>
                <div className={"d-flex justify-space-between"}>
                    <div></div>
                    <CustomSearchInput
                        value={searchTerm}
                        onChange={handleSearch}
                        onClick={handleClear}
                    />
                </div>
                <div className={"table-layout"} style={{ border : isMobile ? 'none' : undefined}}>
                    <Table aria-label="Table with cell actions">
                        <TableHeader className={"list-row"}>
                            <TableRow>
                                {columns.map((column) => (
                                    <TableHeaderCell style={{ width: column.width }} key={column.columnKey}>
                                        <span className={"listHeaderText"}>{column.label}</span>
                                    </TableHeaderCell>
                                ))}
                            </TableRow>
                        </TableHeader>

<TableBody>
  {filteredPosts.length > 0 && filteredPosts.map((item) =>
    isMobile ? (
      <div key={item.id} className="post-approval-card">
        <div className="post-approval-card-header">
          <div className="post-approval-card-title">{item.eventName}</div>
        </div>
        <div className="post-approval-card-row">
          <span className="post-approval-card-label">Name</span>
          <span className="post-approval-card-value">{item.firstName} {item.lastName}</span>
        </div>
         <span className="separator"></span>
        <div className="post-approval-card-row">
          <span className="post-approval-card-label">Status</span>
          <span className="post-approval-card-value">
            {item.status === "0" ? (
              <span style={{ color: 'black', fontWeight: 'bold' }}>Pending</span>
            ) : item.status === "1" ? (
              <span style={{ color: 'green', fontWeight: 'bold' }}>Approved</span>
            ) : item.status === "2" ? (
              <span style={{ color: 'green', fontWeight: 'bold' }}>Approved & Refunded</span>
            ) : (
              <span style={{ color: 'red', fontWeight: 'bold' }}>Decline</span>
            )}
          </span>
        </div>
         <span className="separator"></span>
        <div className="post-approval-card-actions">
          <Button className={"btnBorderOnly"} shape="circular" disabled={item.status === "1" || item.status === "2" || item.status === "3"} onClick={() => {
            setSelectedPost(item);
            approveClick(item);
          }}>Approve</Button>
          {item.disableCharge === false && item.price > 0 && (
            <Button className={"btnBorderOnly"} shape="circular" disabled={item.status === "1" || item.status === "2" || item.status === "3"} onClick={() => {
              setSelectedPost(item);
              approveAndRefundClick(item);
            }}>Approve & Refund</Button>
          )}
          <Button className={"btnBorderOnly"} shape="circular" disabled={item.status === "1" || item.status === "2" || item.status === "3"} onClick={() => {
            setSelectedPost(item);
            declineClick(item); 
          }}>Decline</Button>
        </div>
      </div>
    ) : (
      <TableRow key={item.id}>
        <TableCell className={"table-row-fonts__primary"}>
          <TableCellLayout>
            {item.eventName}
          </TableCellLayout>
        </TableCell>
        <TableCell className={"table-row-fonts__desc"}>
          <TableCellLayout>
            {item.firstName} {item.lastName}
          </TableCellLayout>
        </TableCell>
        <TableCell className="table-row-fonts__desc">
          <TableCellLayout>
            {item.status === "0" ? (
              <span style={{ color: 'black', fontWeight: 'bold' }}>Pending</span>
            ) : item.status === "1" ? (
              <span style={{ color: 'green', fontWeight: 'bold' }}>Approved</span>
            ) : item.status === "2" ? (
              <span style={{ color: 'green', fontWeight: 'bold' }}>Approved & Refunded</span>
            ) : (
              <span style={{ color: 'red', fontWeight: 'bold' }}>Decline</span>
            )}
          </TableCellLayout>
        </TableCell>
        <TableCell>
          <TableCellLayout>
            <div style={{ display: 'flex', gap: '10px' }}>
              <Button className={"btnBorderOnly"} shape="circular" disabled={item.status === "1" || item.status === "2" || item.status === "3"} onClick={() => {
                setSelectedPost(item);
                approveClick(item);
              }}>Approve</Button>
              {item.disableCharge === false && item.price > 0 && (
                <Button className={"btnBorderOnly"} shape="circular" disabled={item.status === "1" || item.status === "2" || item.status === "3"} onClick={() => {
                  setSelectedPost(item);
                  approveAndRefundClick(item);
                }}>Approve & Refund</Button>
              )}
              <Button className={"btnBorderOnly"} shape="circular" disabled={item.status === "1" || item.status === "2" || item.status === "3"} onClick={() => {
                setSelectedPost(item);
                declineClick(item); 
              }}>Decline</Button>
            </div>
          </TableCellLayout>
        </TableCell>
      </TableRow>
    )
  )}
</TableBody>

                    </Table>
                </div>
                <div style={{ marginTop: '10px', textAlign: 'center' }}>
                    {isLoading && <Spinner />} {/* Render loader if loading state is true */}
                    {!isLoading && hasMoreData && searchTerm == "" && <Button onClick={handleLoadMore}>Load More...</Button>} {/* Render button if not loading */}
                </div>
            </div>
            <ImageDialog open={open} setOpen={setOpen} selectedEvent={selectedPost}></ImageDialog>
        </Layout>
    )
}

export default EventRSVPCancelRequest;


function makeLinksClickable(text) {
    return text.replace(/(https?:\/\/\S+)/g, '<a href="$1" target="_blank">$1</a>');
}